<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                  Forgot Password                                    │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <div class="rewards-forgot-password">
        <!-- This is titled this way on purpose [JBP] -->
        <h3 class="rewards-title">Reset Password</h3>

        <div class="form-fields">
            <div class="user-input">
                <p class="caption" v-if="posted">
                    Your request is being processed. Please check your email.
                </p>

                <template v-else>
                    <p class="caption">
                        Enter the email address associated with your {{ TEXT.REWARDS_PROGRAM }} account.
                        You will receive an email with instructions to reset your password.
                    </p>

                    <labeled-text-input name="email" id="memberEmail" class="member-email"
                                        v-model="email"
                                        type="email"
                                        @change="resetErrors()"
                                        @submit="onSubmit()"
                                        has-icon>Email</labeled-text-input>
                </template>
            </div>

            <div class="user-action">
                <button class="button" @click.prevent="closeDialog()" v-if="posted">Ok</button>
                <button class="button" @click.prevent="onSubmit()" v-else>Submit</button>
            </div>
        </div>

        <div class="errors">
            <ul v-for="(error, index) in errorDict" :key="index">
                <li>{{ error }}</li>
            </ul>
        </div>

        <transition-expand v-if="error || exception" classList="conflicts-container">
            <conflicts :error.sync="error" :exception.sync="exception" :is-sys-admin="isSysAdmin"></conflicts>
        </transition-expand>
    </div>
</template>


<script>
    import { fetchJSON, postJSON } from "@/helpers/fetch"
    import conflicts, { CONFLICTS } from "@/common/conflicts"

    export default {
        components: { conflicts },
        mixins: [CONFLICTS],

        emits: ['submitting', 'submitted', 'close'],

        name: 'ForgotPassword',
        data() {
            return {
                email: null,
                phone: null,
                passport: null,
                nationalId: null,

                posted: false,
                errorDict: {},

                submitting: false,
            }
        },

        methods: {
            onSubmit() {

                //Validation
                this.errorDict = {};

                var regexEmailCheck = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email);

                if (!regexEmailCheck || this.email == null) this.errorDict["Email"] = "Please enter a valid email address.";
                if (this.email) {
                    if (this.email.length == 0) this.errorDict["EmailLength"] = "Email address cannot be left blank";
                }

                //If there are no errors in the errorDict, proceed with fetchJSON function to Login
                if (Object.keys(this.errorDict).length === 0) {
                    if (this.submitting) {
                        alert('Processing; please wait ...')
                    }
                    else {
                        this.$emit('submitting')
                        this.submitting = true

                        postJSON(`/api/members/ForgotPassword`, {
                            email: this.email,
                            phone: this.phone,
                            passport: this.passport,
                            nationalId: this.nationalId
                        })
                            .then(() => {
                                this.posted = true
                            })
                            .catch(this.onThrow)
                            .finally(() => {
                                this.$emit('submitted')
                                this.submitting = false
                            })
                    }
                }
            },

            closeDialog() {
                this.$emit('close')
            }
        }
    }
</script>
